<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="paymentDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Payment Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="paymentDate"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-container v-if="adminUpcomingPayments.length > 0">
          <v-data-table
            :headers="table.headers"
            :items="adminUpcomingPayments"
            item-key="name"
            class="elevation-1"
            :search="table.search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="table.search"
                label="Search"
                class="mx-4"
              ></v-text-field>
            </template>
            <template #item.link="{ item }">
              <a target="_blank" :href="orderLink(item.id)">
                View on Master Site
              </a>
            </template>
          </v-data-table>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UPCOMING_PAYMENTS_QUERY } from "@/graphql/queries/billing";

export default {
  name: "UpcomingPayments",
  data() {
    return {
      adminUpcomingPayments: [],
      menu1: false,
      paymentDate: null,
      table: {
        search: '',
        headers: [
          {
            text: 'First Name',
            align: 'start',
            sortable: true,
            value: 'user.firstName'
          },
          { text: 'Surname', value: 'user.lastName', sortable: true },
          { text: 'Email', value: 'user.email', sortable: true },
          { text: 'Billing Period', value: 'billingPeriod', sortable: true },
          { text: 'Migrated From Payfast', value: 'migratedFromPayfast'},
          { text: "Link", value:"link", sortable: false }
        ]
      }
    }
  },
  methods: {
    orderLink(id) {
      return `${this.$appApiEndPoint}/admin/billing/order/${id}/change`;
    }
  },
  apollo: {
    adminUpcomingPayments: {
      query: UPCOMING_PAYMENTS_QUERY,
      variables() {
        return {
          date: this.paymentDate,
        };
      },
      skip() {
        return this.paymentDate === null;
      }
    }
  }
}
</script>